export default {
  title: {
    information: 'Information',
    confirmation: 'Confirmation required'
  },
  confirmAction: 'Are you sure to perform this action?',
  reconnect: 'Reconnect'
}
